import builder from '../builder';
import SignBadgeCircleAlternate from '../../streamline-icons/bold/sign-badge-circle-alternate.svg';

export default builder(
  'IconSignBadgeCircleAlternateBold',
  SignBadgeCircleAlternate,
);
